import React, { Component } from 'react';

import classNames from 'classnames';
import { AsyncImage } from 'components/asyncImage';
import { I18n } from 'components/translate';
import isEqual from 'lodash/isEqual';
import { getFileLink } from 'modules/file/helpers';
import PropTypes from 'prop-types';

import FileService from '../FileService';

import { UploadConsumer, UploadProptypes } from '@hotmart/club-files-ui';

import './BoxImageUploadActions.scss';

class BoxImageUploadFilled extends Component {
  // #region setup
  static propTypes = {
    fileUpload: UploadProptypes.fileUpload,
    deleteFile: PropTypes.func,
    replaceFile: PropTypes.func,
    image: PropTypes.object,
    crop: PropTypes.bool,
    canReplace: PropTypes.bool,
    full: PropTypes.bool,
    reusable: PropTypes.bool
  };

  static defaultProps = {
    crop: false,
    canReplace: true
  };

  shouldComponentUpdate(nextProps) {
    return !isEqual(nextProps.image, this.props.image);
  }
  // #endregion

  // #region handlers
  get id() {
    const { image } = this.props;

    return image.fileId || image.id;
  }
  // #endregion

  replaceFile = () => {
    const { fileUpload, reusable } = this.props;

    if (!fileUpload) {
      return;
    }

    if (reusable) {
      fileUpload.actions.openLibrary({
        replaceId: this.id,
        onOpenLibrary: FileService.onLibraryOpen
      });
    } else {
      fileUpload.actions.replace(this.id);
    }
  };

  deleteFile = () => {
    const { fileUpload } = this.props;

    if (!fileUpload) {
      return;
    }

    fileUpload.actions.delete(this.id);
  };

  render() {
    const { crop, canReplace, full } = this.props;

    const fileLink = getFileLink(this.id);

    const classComponent = classNames(
      'dropzone__action__button',
      'dropzone__action__button--with-media',
      { 'dropzone__action__button--full': full }
    );

    return (
      <div className={classComponent}>
        {crop ? (
          <AsyncImage className="action__background" url={fileLink} />
        ) : (
          <AsyncImage className="action__image" url={fileLink} />
        )}
        <div className="action__controls">
          {canReplace && (
            <label>
              <span onClick={this.replaceFile}>
                <I18n label="general.change" />
              </span>
            </label>
          )}
          <label>
            <span onClick={this.deleteFile}>
              <I18n label="general.remove" />
            </span>
          </label>
        </div>
      </div>
    );
  }
}

const withUploader = UploadConsumer()(BoxImageUploadFilled);

export { BoxImageUploadFilled };
export default withUploader;
